<template>
  <b-dropdown block right text="Filter" variant="primary" class="button__filter">
    <b-dropdown-form>
      <b-form-group>
        <b>Categories</b>
        <b-form-checkbox-group
          ref="categories-checkbox"
          v-model="$_vModel.categories"
          :options="optionCategories"
          name="categories-checkbox"
          stacked
          :disabled="disabled"
        ></b-form-checkbox-group>
      </b-form-group>

      <b-form-group class="mb-0 mc-type">
        <b>Type</b>
        <b-form-radio-group v-model="$_vModel.type" name="type-radio" stacked :disabled="disabled">
          <template v-for="option in optionTypes">
            <b-form-radio
              :key="option.text"
              :ref="`type-radio--${option.value}`"
              :value="option.value"
            >
              {{ option.text }}
            </b-form-radio>
          </template>
        </b-form-radio-group>
      </b-form-group>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import Category from '@/models/Category';

export default {
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: {
      type: Object,
      requried: true,
      default: () => ({
        categories: [],
        type: 'all'
      })
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      optionTypes: [
        { text: 'All', value: 'all' },
        { text: 'Learn + Verify', value: 'learn-verify' },
        { text: 'Verify', value: 'verify' }
      ]
    };
  },

  computed: {
    $_vModel: {
      get() {
        return this.vModel;
      },

      set(v) {
        this.$emit('change', v);
      }
    },

    optionCategories() {
      const categories = Category.all();

      return categories.map((x) => {
        return { text: x.name, value: x.slug };
      });
    }
  }
};
</script>

<style lang="scss">
.custom-checkbox {
  margin: 0.5rem 0;
}

.dropdown-menu {
  min-width: max-content;
}

.custom-radio {
  margin: 0.5rem 0;
}
</style>
